export default __webpack_public_path__ + "static/pool-forme1-cde9b5834fd0e69a30a0f8d33e28854e.svg";